import { Link } from "react-router-dom";
import { LegalLayout, H2, P, UL, LI } from "../components/site/LegalLayout";
import { EMAIL, PHONE_DISPLAY, ADDRESS_LINE1, ADDRESS_LINE2 } from "../lib/site";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="PRIVACY POLICY"
      updated="June 2026"
      intro="Scrapmans Metal Recycling LLC respects your privacy. We collect only what we need to respond to your inquiry, and we never sell your information."
      testid="privacy-policy-page"
    >
      <H2>Who We Are</H2>
      <P>
        This website is operated by Scrapmans Metal Recycling LLC ("Scrapman's", "we", "us" or "our"),
        located at {ADDRESS_LINE1}, {ADDRESS_LINE2}. This policy explains what information we collect
        through this website, how we use it, and the choices you have.
      </P>

      <H2>Information We Collect</H2>
      <P>We collect information in two ways:</P>
      <UL>
        <LI>
          <strong>Information you give us.</strong> When you submit the bulk scrap quote form, we collect
          your name, phone number, email address, general location (city or county), the material type and
          approximate quantity, any description you provide, and any photos of your material that you choose
          to upload.
        </LI>
        <LI>
          <strong>Information collected automatically.</strong> Like most websites, our hosting provider
          records basic technical information such as IP address, browser type and the date and time of your
          visit for security and reliability purposes. We do not use advertising cookies, Google Analytics,
          Meta Pixel, or any third-party marketing or behavioral tracking on this site.
        </LI>
      </UL>

      <H2>How We Use Your Information</H2>
      <UL>
        <LI>To review your load details and respond with pricing, drop-off or pickup information.</LI>
        <LI>To contact you by phone or email about your inquiry.</LI>
        <LI>To keep an internal record of quote requests for our own business purposes.</LI>
        <LI>To protect our website and business, and to comply with applicable law.</LI>
      </UL>
      <P>
        We do not use your information to send marketing or promotional email blasts, and we do not send
        text messages from this website.
      </P>

      <H2>We Do Not Sell Your Information</H2>
      <P>
        We do not sell, rent or trade your personal information. We share it only with service providers who
        help us operate this website and our email notifications (for example, our website host, database
        provider and email delivery provider), and only to the extent needed to provide those services. We
        may also disclose information if required by law, subpoena, or a lawful request from law enforcement,
        or where necessary to protect our rights, property or safety.
      </P>

      <H2>Photos You Upload</H2>
      <P>
        Photos you submit with a quote request are stored with your request and used to help us evaluate your
        material. Please do not include images containing sensitive personal information, documents,
        identification, or people who have not agreed to be photographed.
      </P>

      <H2>Third-Party Content</H2>
      <P>
        Our contact section includes an embedded Google Maps frame so you can find our yard. When that map
        loads, Google may collect information about your device and visit under its own privacy policy. We do
        not control and are not responsible for Google's practices. Links to external sites, including our
        Google Business profile, are also governed by those sites' own policies.
      </P>

      <H2>How Long We Keep Information</H2>
      <P>
        We keep quote requests for as long as reasonably necessary for our business and recordkeeping needs,
        or as required by law, and then delete or archive them.
      </P>

      <H2>Security</H2>
      <P>
        We use reasonable administrative and technical safeguards to protect the information submitted
        through this site, including encrypted (HTTPS) transmission. No method of transmission or storage is
        completely secure, however, and we cannot guarantee absolute security.
      </P>

      <H2>Children</H2>
      <P>
        This website is not directed to children under 13, and we do not knowingly collect personal
        information from them. If you believe a child has submitted information to us, contact us and we will
        delete it.
      </P>

      <H2>Your Choices and Rights</H2>
      <P>
        You may contact us at any time to ask what information we hold about you, to correct it, or to ask us
        to delete it. Depending on where you live, you may have additional rights under state privacy laws.
        We will respond to reasonable requests as required by applicable law. To make a request, email{" "}
        <a href={`mailto:${EMAIL}`} className="text-red-700 font-semibold underline underline-offset-2">
          {EMAIL}
        </a>{" "}
        or call {PHONE_DISPLAY}.
      </P>
      <P>
        Note that separate from this website, Ohio law requires scrap metal dealers to record and retain
        certain seller information for purchase transactions. Those records are kept as required by law and
        are not subject to deletion requests. See our{" "}
        <Link to="/scrap-seller-policy" className="text-red-700 font-semibold underline underline-offset-2">
          Scrap Seller Policy
        </Link>
        .
      </P>

      <H2>Changes to This Policy</H2>
      <P>
        We may update this policy from time to time. The revised version will be posted on this page with a
        new "last updated" date.
      </P>

      <H2>Contact Us</H2>
      <P>
        Scrapmans Metal Recycling LLC
        <br />
        {ADDRESS_LINE1}, {ADDRESS_LINE2}
        <br />
        Phone: {PHONE_DISPLAY}
        <br />
        Email:{" "}
        <a href={`mailto:${EMAIL}`} className="text-red-700 font-semibold underline underline-offset-2">
          {EMAIL}
        </a>
      </P>
    </LegalLayout>
  );
}
